import { awsRum } from './utils/awsRum.utils';

// Initializes CloudWatch RUM browser monitoring. (The server includes the RUM configuration
// in the HTML page, if RUM is enabled.)
//
// This module should be imported first in the client entry point, so that RUM is initialized
// before the rest of the application's modules are evaluated (and thus can record errors thrown
// while they are evaluated). Let's keep imports here minimal for the same reason.

if (window.__AWS_RUM_CONFIG__) {
  awsRum.init(window.__AWS_RUM_CONFIG__, window.__RELEASE_ID__);
}
